import React, { useState } from 'react';
import './App.scss';
import { Layout, theme } from 'antd';
import config from './config.json';
import { Route, Routes, useLocation } from 'react-router-dom';
import NotFound from './components/NotFound';
import LoginPage from './components/Login/Login';
import BaseFooter from './components/Footer/BaseFooter';
import CustomHeader from './components/Header/CustomHeader';
import SideMenu from './components/Sidebar/Sidebar';
import HistorySidebar from './components/History/History';
import GlobalFloatButton from './components/QuickActions/QuickActions';
import ResetPwdPage from './components/Login/ResetPwd';
import ForgotPwdPage from './components/Login/ForgotPwd';
import Users from './components/Users/Users';
import Events from './components/Events/Events';
import HomePage from './components/HomePage/HomePage';
import PrivateRoute from './components/Login/PrivateRoute';
import { AuthProvider } from './components/Login/AuthProvider';
import { NotificationProvider } from './Helper/NotificationProvider';
import Customers from './components/Customers/Customers';
import Locations from './components/Locations/Locations';
import { useSelector } from 'react-redux';
import Matchings from './components/Events/Matchings/Matchings';
import ImageOverview from './components/ImageOverview/ImageOverview';
import { Roles } from './constants/roles';
import EditorWrapper from './components/Locations/Editor/Wrapper/EditorWrapper';

const { Content } = Layout;

function App() {
  const location = useLocation();
  const {
    token: { colorBgContainer }
  } = theme.useToken();
  const collapsed = useSelector(state => state.sidebar.isCollapsed);

  const getComponentByLabel = label => {
    const componentMap = {
      Home: <HomePage />,
      Events: <Events />,
      Locations: <Locations />,
      Images: <ImageOverview />,
      Customers: <Customers />,
      Users: <Users />,
    };
    return componentMap[label] || null;
  };

  const [isSaving, setIsSaving] = useState(false);

  return (
      <AuthProvider>
        <NotificationProvider>
          <div className="app-container">
            {location.pathname !== '/login' &&
              location.pathname !== '/resetPwd' &&
              location.pathname !== '/forgotPwd' && (
                <Layout>
                  <CustomHeader />
                  <Layout
                    style={{
                      overflowX: 'auto'
                    }}
                  >
                    <SideMenu />
                    <HistorySidebar />
                    {(location.pathname.includes('events') ||
                     location.pathname.includes('locations')) &&
                      <GlobalFloatButton />
                    }
                    <Content
                      width="100%"
                      style={{
                        marginLeft: collapsed ? '60px' : '200px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <Routes>
                        <Route path="/locations" element={<Locations />} />
                        {config.menuItems.children.map(entry => {
                          const { key, label } = entry;
                          let requiredRoles;
                          switch (label) {
                            case 'Home':
                              requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
                              break;
                            case 'Events':
                              requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
                              break;
                            case 'Locations':
                              requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
                              break;
                            case 'Images':
                              requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
                              break;
                            case 'Customers':
                              requiredRoles = [Roles.SYSTEM_ADMIN];
                              break;
                            case 'Users':
                              requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN];
                              break;
                            default:
                              requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
                          }
                          const element = getComponentByLabel(label);
                          return (
                            <Route
                              key={key}
                              path={key}
                              element={<PrivateRoute requiredRoles={requiredRoles}/>}
                            >
                              <Route index element={element} />
                              {key === 'locations' && (
                                <Route path="editor" element={
                                  <EditorWrapper isSaving={isSaving} setIsSaving={setIsSaving} />
                                } />
                              )}
                              {key === 'events' && (
                                <Route path="matchings" element={
                                  <Matchings />
                                } />
                              )}
                            </Route>
                          );
                        })}
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </Content>
                  </Layout>
                  <BaseFooter />
                </Layout>
              )}
            <Routes>
              <Route key={'login'} path={'/login'} element={<LoginPage />} />
              <Route
                key={'resetPwd'}
                path={'/resetPwd'}
                element={<ResetPwdPage />}
              />
              <Route
                key={'forgotPwd'}
                path={'/forgotPwd'}
                element={<ForgotPwdPage />}
              />
            </Routes>
          </div>
        </NotificationProvider>
      </AuthProvider>
  );
}

export default App;
